import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { 
  FiHome, 
  FiCheckSquare, 
  FiFileText, 
  FiBell, 
  FiX 
} from 'react-icons/fi';
import './Sidebar.css';

interface SidebarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
}

interface MenuItem {
  path: string;
  icon: JSX.Element;
  labelKey: string;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, toggleSidebar }) => {
  const { t } = useTranslation();
  
  const menuItems: MenuItem[] = [
    { path: '/dashboard', icon: <FiHome />, labelKey: 'navigation.dashboard' },
    { path: '/tasks', icon: <FiCheckSquare />, labelKey: 'navigation.tasks' },
    { path: '/notes', icon: <FiFileText />, labelKey: 'navigation.notes' },
    { path: '/reminders', icon: <FiBell />, labelKey: 'navigation.reminders' },
  ];

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar}></div>
      )}
      
      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <h2 className="sidebar-title">
            <span className="sidebar-icon">📋</span>
            {t('navigation.dashboard')}
          </h2>
          <button className="sidebar-close-btn" onClick={toggleSidebar}>
            <FiX />
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => 
                `sidebar-link ${isActive ? 'active' : ''}`
              }
              onClick={() => window.innerWidth <= 1024 && toggleSidebar()}
            >
              <span className="sidebar-link-icon">{item.icon}</span>
              <span className="sidebar-link-text">{t(item.labelKey)}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <p className="sidebar-footer-text">
            v1.0.0
          </p>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;

